'use strict';

import ModalView from '../../js/components/ModalView';
import PromotionalGiveawayModalTemplate from './templates/_PromotionalGiveawayModal.hbs';

export default ModalView.extend({
  template: PromotionalGiveawayModalTemplate
});


// WEBPACK FOOTER //
// ./assets/components/PromotionalGiveaway/PromotionalGiveawayModal.js